import { useState, useEffect, React } from "react";
import SidebarStyles from "./Sidebar.module.css";
import { Link } from "react-router-dom";
import Logo from "components/Logo";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { Box } from "@mui/material";
import ConditionalWrapper from "common/ConditionalWrapper";

import AximTooltip from "components/AximTooltip";

function Sidebar(props) {
  const [menuIcon, setMenuIcon] = useState(false);

  const handleMenuIcon = () => {
    setMenuIcon(!menuIcon);
  };

  useEffect(() => {
    var currentPage = props.data?.find(sd => window.location.pathname === sd.link);

    if (currentPage !== undefined) {
      props.changeTitle(currentPage.title);
    }
  }, [props.changeTitle]);  //props.changeTitle() -- this is causing a render warning, I think it needs to be change of the method and not calling the method.

  return (
    <div
      className={`${SidebarStyles.sidebarWrapper} ${
        !props.siderbarClosed ? SidebarStyles.closed : ""
      }`}
    >
      <Logo logoStyle="sidebar-logo" smallLogo={!props.logoToggle} />
      <div
        className={`${SidebarStyles.toggleSidebarIcon} ${
          props.sidebarToggleIcon ? SidebarStyles.active : ""
        }`}
        onClick={props.toggleHandler}
      >
        {!menuIcon ? (
          <ArrowForwardIosOutlinedIcon
            className={SidebarStyles.toggle}
            onClick={handleMenuIcon}
          />
        ) : (
          <ArrowBackIosOutlinedIcon
            className={SidebarStyles.toggle}
            onClick={handleMenuIcon}
          />
        )}
      </div>
      <ul>
        {props.data.map((val, i) => {
          let isActive = window.location.pathname === val.link;

          return (
            <ConditionalWrapper
              key={`sidebar-wrapper-${i}`}
              condition={!props.siderbarClosed}
              wrapper={children => (
                <AximTooltip title={val.title} arrow placement="right">
                  {children}
                </AximTooltip>
              )}>
              <Box
                component="li"
                className={isActive ? "active" : ""}
                sx={{backgroundColor: isActive ? "primary.main" : "white" }}
              >
                {val.isExternalLink ?
                  <a href={val.link} target="_blank">
                    <Box className={SidebarStyles.menuIcon} sx={{color: isActive ? "primary.contrastText" : "primary.main"}}>{val.icon}</Box>
                    <Box className={SidebarStyles.menuTitle} sx={{color: isActive ? "primary.contrastText" : "primary.main"}}>{val.title}</Box>
                  </a>
                :
                <Link to={val.link}>
                  <Box className={SidebarStyles.menuIcon} sx={{color: isActive ? "primary.contrastText" : "primary.main"}}>{val.icon}</Box>
                  <Box className={SidebarStyles.menuTitle} sx={{color: isActive ? "primary.contrastText" : "primary.main"}}>{val.title}</Box>
                </Link>}
                {""}
              </Box>
            </ConditionalWrapper>
          );
        })}
      </ul>
      <div className={SidebarStyles.actions}>
        <Link className={SidebarStyles.logout} to="/logout">
          <PowerSettingsNewOutlinedIcon />{" "}
          <span className={SidebarStyles.hideContent}>Logout</span>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
